import { Box, Typography } from "@mui/material"
import React, { useState } from "react"
import { Ingredient } from "../../../../types/types"
import './IngredientButton.scss'

export type IngredientButtonProps = {
    ingredient: Ingredient;
    onSelect: any;
    selected: boolean;
}

const IngredientButton = (props: IngredientButtonProps) => {
    let thumbnailUrl = props.ingredient?.thumbnailUrl
    thumbnailUrl = thumbnailUrl || 'https://via.placeholder.com/200x150'

    const [selected, setSelected] = useState(false)

    const handleSelect = () => {
        setSelected(!selected)
        props.onSelect(props.ingredient)
    }

    let name = props.ingredient.name

    //name = `${props.ingredient.number} ${props.ingredient.name}`
    name = `${props.ingredient.name}`


    return (
        <Box className="ingredient-button-wrapper">
            {/* {selected &&
                <Box className="selection-indicator"></Box>
            } */}

            <Box
                className="availability-indicator"
                data-available={props.ingredient.available}
            />
            <Box
                className="ingredient-button"
                onClick={handleSelect}
                sx={{
                    height: 100,
                    width: '100%'
                }}
            >
                <Typography>{name}</Typography>

            </Box>
        </Box>

    )
}



export default IngredientButton